import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { shareReplay } from "rxjs/operators";

export type DesignKind = "classic" | "modern";
const STORAGE_KEY = "app:design";

@Injectable({ providedIn: "root" })
export class DesignService {
  private readonly designSubject = new BehaviorSubject<DesignKind>(
    this.readInitial()
  );
  readonly design$ = this.designSubject.asObservable().pipe(shareReplay(1));

  constructor() {
    // Apply initial class immediately
    this.applyClass(this.designSubject.value);

    // Persist and re-apply when value changes
    this.design$.subscribe((d) => {
      this.persist(d);
      this.applyClass(d);
    });
  }

  setDesign(d: DesignKind) {
    this.designSubject.next(d);
  }

  getDesign(): DesignKind {
    return this.designSubject.getValue();
  }

  private readInitial(): DesignKind {
    try {
      const stored = localStorage.getItem(STORAGE_KEY) as DesignKind | null;
      if (stored === "modern" || stored === "classic") return stored;
    } catch (e) {
      // ignore
    }
    return "modern";
  }

  private persist(d: DesignKind) {
    try {
      localStorage.setItem(STORAGE_KEY, d);
    } catch (e) {
      // ignore
    }
  }

  private applyClass(d: DesignKind) {
    try {
      const root = document.documentElement;
      root.classList.remove("design-classic", "design-modern");
      root.classList.add(`design-${d}`);
    } catch (e) {
      // ignore (server-side rendering or restricted env)
    }
  }
}
